import { useParams } from "react-router-dom";
import { useEffect, useState,useCallback } from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,Box,Stack,IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import BASE_URL from "../config";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from '@mui/icons-material/Delete';
import praLogo from "../assets/pra_logo.jpg";
import { toWords } from "number-to-words";
const PaymentPage = () => {
  const { studentId } = useParams();
  const [paymentDetails, setPaymentDetails] = useState({});
  const [fees, setFees] = useState([]);
  //const [receiptId, setReceiptId] = useState(null);
  const [description, setDescription] = useState("");
  //const [paymentMethod, setPaymentMethod] = useState("");
  const [payingNow, setPayingNow] = useState({});
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [dett, setdett] = useState({});
  const [concessions, setConcessions] = useState([]);
  const [disabledApply, setDisabledApply] = useState(fees.map(() => false));
  const [paymentMethods, setPaymentMethods] = useState({});
  const [paymentBreakdown, setPaymentBreakdown] = useState({});
  const [paidFees, setPaidFees] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  //Concession Refered BY
  const [showConcessionModal, setShowConcessionModal] = useState(false);
const [currentFeeIndex, setCurrentFeeIndex] = useState(null);
const [concessionReferredBy, setConcessionReferredBy] = useState("");
/* const [installmentType, setInstallmentType] = useState({});
const [utrNumbers, setUtrNumbers] = useState({}); */
  const fetchFees = useCallback(async () => {
    if (!dett.courseId || !dett.academicYearId || !dett.classId || !studentId) return;
  
    try {
      const response = await axios.get(`${BASE_URL}/api/studentFees`, {
        params: {
          studentId: studentId,
          courseId: dett.courseId,
          academicYearId: dett.academicYearId,
          classId: dett.classId,
        },
      });
  
      setFees(response.data);
    } catch (error) {
      console.error("Error fetching fees:", error);
    }
  }, [studentId, dett.courseId, dett.academicYearId, dett.classId]); 
  useEffect(() => {
    const storedDetails = JSON.parse(localStorage.getItem("paymentDetails"));
    const det = JSON.parse(localStorage.getItem("paymentDetails1"));
    if (storedDetails) {
      setPaymentDetails(storedDetails);
    }
    if (det) {
      setdett(det);
    }
    //fetchReceiptId();
    fetchFees();
  }, [fetchFees]);

  useEffect(() => {
    if (dett && dett.courseId && dett.academicYearId && dett.classId) {
      fetchFees();
    }
  }, [dett,fetchFees]);
  useEffect(() => {
    if (studentId && dett.academicYearId && dett.courseId && dett.classId) {
    const fetchPaidFees = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/getPaidFees`, {
          params: {
            studentId,
            academicYearId: dett.academicYearId,
            courseId: dett.courseId,
            classId: dett.classId,
          },
        });
        setPaidFees(response.data);
      } catch (error) {
        console.error("Error fetching paid fees:", error);
      }
    };
  
    fetchPaidFees();
  }
  }, [studentId, dett.academicYearId, dett.courseId, dett.classId]); // Add necessary dependencies
  const handleConcessionChange = (e, index, fee) => {
    const value = parseFloat(e.target.value) || 0;
    setConcessions(prev => {
      const updatedConcessions = [...prev]; 
      updatedConcessions[index] = value;
      return updatedConcessions;
    });
    // if any amount entered, show modal for referredBy
  if (value > 0) {
    setCurrentFeeIndex(index);
    //setShowConcessionModal(true);
  }
  };
  const handleApplyConcession = async (index,referredBy) => {
    const fee = fees[index];
    const concessionAmount = Array.isArray(concessions) && concessions[index] ? concessions[index] : 0;
    const finalAmount = Math.max(fee.Fees - concessionAmount, 0);
    // Ensure concession does not exceed fees
    if (concessionAmount > fee.Fees) {
      alert("Concession cannot be greater than the Amount.");
      return;
    }
    try {
       // Insert record into Concession table
     await axios.post(`${BASE_URL}/api/addConcession`, {
      date: selectedDate,  // selectedDate from the DatePicker component
      studentId,
      categoryId: fee.CategoryID,
      academicYearId: dett.academicYearId,
      courseId: dett.courseId,
      classId: dett.classId,
      fees: fee.Fees,
      concessionAmount,
      finalAmount,
      concessionReferredBy: referredBy,
      createdBy: sessionStorage.getItem("adminName"),
    });
    if (concessionAmount > 0) {
      // Update CategoryFee table
      await axios.post(`${BASE_URL}/api/updateCategoryFee`, {
        studentId,
        categoryId: fee.CategoryID,
        academicYearId: dett.academicYearId,
        courseId: dett.courseId,
        classId: dett.classId,
        concessionAmount,
      });
      // Update TotalFee table
       await axios.post(`${BASE_URL}/api/updateTotalFee`, {
        studentId,
        academicYearId: dett.academicYearId,
        courseId: dett.courseId,
        classId: dett.classId,
        concessionAmount,
      });
    }
      // Update the state to reflect the new final amount
      const updatedFees = [...fees];
      updatedFees[index].finalAmount = finalAmount;
      setFees(updatedFees);
  // ✅ **Update balance in UI immediately**
  setFees((prevFees) => {
    const updatedFees = [...prevFees];
    updatedFees[index] = {
      ...updatedFees[index],
      finalAmount,
      balance: fee.Fees - fee.TotalPaid - concessionAmount, // Adjust balance
    };
    return updatedFees;
  });
  // ✅ **Disable Apply button and reset concession input**
  setDisabledApply((prev) => {
    const updatedDisabledApply = [...prev];
    updatedDisabledApply[index] = true;
    return updatedDisabledApply;
  });
  setConcessions((prev) => {
    const updatedConcessions = [...prev];
    updatedConcessions[index] = 0;
    return updatedConcessions;
  });
      alert("Concession applied successfully!");
    } catch (error) {
      console.error("Error applying concession:", error);
      alert("Failed to apply concession. Please try again.");
      //setError("Failed to apply concession. Please try again.");
    }
  };
  const handlePaymentMethodChange = (event, categoryId) => {
    const value = event.target.value;
    setPaymentMethods((prev) => ({ ...prev, [categoryId]: value }));
    // Reset breakdown when changing method
    setPaymentBreakdown((prev) => ({ ...prev, [categoryId]: { cash: "", phonepe: "" } }));
  };
  const handleBreakdownChange = (event, categoryId, method) => {
    const value = parseFloat(event.target.value) || 0;
    setPaymentBreakdown((prev) => {
      const updatedCategory = {
        ...prev[categoryId],
        [method]: value,
      };
      // Calculate total amount by summing all payment methods
      const totalAmount = Object.values(updatedCategory).reduce((sum, amt) => sum + (amt || 0), 0);
      setPayingNow((prev) => ({
        ...prev,
        [categoryId]: totalAmount,
      }));
      return {
        ...prev,
        [categoryId]: updatedCategory,
      };
    });
  };
    const resetPaymentState = () => {
      //setSelectedDate(null);
      setDescription("");
      setPayingNow({});
      setPaymentBreakdown({});
    };
    const handleSavePayment = async () => {
      try {
        setIsSaveDisabled(true);
        debugger;
        const payload = {
          studentId,
          courseId: dett.courseId,
          classId: dett.classId,
          academicYearId: dett.academicYearId,
          selectedDate,
          createdBy: sessionStorage.getItem("adminName"),
         /*  utrNumber: utrNumbers[fees.CategoryID] || null,
          installmentType, */
          description,
          payments: fees.map((fee) => ({
            categoryId: fee.CategoryID,
             headId: fee.HeadID, // ✅ IMPORTANT
            academicYearId: fee.AcademicYearID, // ✅ IMPORTANT
            amount: payingNow[fee.CategoryID] || 0,
            breakdown: paymentBreakdown[fee.CategoryID] || {},
          })),
        };
        let isValid = true;
        let errorMessage = "";
      debugger;
        fees.forEach((fee) => {
          const balance = parseFloat(fee.balance) || 0;
          const payingNowAmount = parseFloat(payingNow[fee.CategoryID]) || 0;
      
          if (payingNowAmount > balance) {
            isValid = false;
            errorMessage = `Paying Now amount for ${fee.CategoryName} cannot be greater than the balance!`;
          }
        });
      
        if (!isValid) {
          alert(errorMessage);
          setIsSaveDisabled(false); // Re-enable if validation fails
          return;
        }
        await axios.post(`${BASE_URL}/api/savePayment`, payload);
    alert("Payment successfully recorded!");
    // Disable Save button
    setIsSaveDisabled(true);
     // **Reset the state to the initial state**
     resetPaymentState(); // This function should reset state variables
    fetchFees();
  } catch (error) {
    console.error("Error saving payment:", error);
    alert("Failed to save payment. Please try again.");
    setIsSaveDisabled(false); // Re-enable on failure
  }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};
  const handlePrint = async (receiptId) => {
    /*  try { */
    const response = await axios.get(
      `${BASE_URL}/api/receiptDetails/${receiptId}`
    );

    const receiptRows = response.data;

    if (!receiptRows.length) {
      alert("No receipt found");
      return;
    }

    const fee = receiptRows[0];

    const totalAmount = receiptRows.reduce(
      (sum, row) => sum + Number(row.PaidFees),
      0
    );

    const feeRows = receiptRows
      .map(
        (row, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${row.CategoryName}</td>
          <td>${Number(row.PaidFees).toFixed(2)}</td>
        </tr>
      `
      )
      .join("");

    const amountWords =
      "Rupees " +
      toWords(Math.round(totalAmount)) +
      " Only";
    // Convert to a number safely
    /* const fees = fee.PaidFees ? Number(fee.PaidFees).toFixed(2) : "0.00";
    const totalFee = fee.TotalFee ? Number(fee.TotalFee).toFixed(2) : "0.00";
    const balance = fee.Balance ? Number(fee.Balance).toFixed(2) : "0.00";
    const amountWords =
  "Rupees " +
  toWords(Math.round(Number(fees))) +
  " Only"; */
    const receiptContent = `
      <html>
      <head>
        <title>Fee Receipt</title>
        <style>
          body { font-family: Arial, sans-serif; text-align: center; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #000; padding: 8px; text-align: left; }
          .bold { font-weight: bold; }
          .center { text-align: center; }
          .right { text-align: right; }
          .header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;
     /*  margin-bottom: 15px; */
    }
    .logo {
      width: 70px;
      height: 70px;
    }
      .school-details {
  display: flex;
  flex-direction: column;
  align-items: center;
}
    .college-name {
      font-size: 22px;
      font-weight: bold;
    }
      .trust-name{
  font-size:18px;
  font-weight:bold;
}
  .address{
  font-size:14px;
}
  .receipt{
  width:100%;
  min-height:48%;
}

.cutline {
  border-top: 1px solid black;
  margin: 8px 0;
}
  .copy-title {
  text-align: center;
  font-weight: bold;
  font-size: 13px;
  border: 1px solid #000;
  display: inline-block;
  padding: 2px 10px;
  margin-bottom: 5px;
}
  .signature-table {
  width: 100%;
   border:none;
  margin-top: 40px;
}

.signature-table td {
  border: none;
   width:50%;
}
   .sign-box{
  border-top:2px solid #000 !important;
  padding-top:6px;
}
  .signature-line{
  border-top:2px solid #000;
  width:180px;
  margin: 0 auto 5px auto; /* centers the line */
}
  .sign-cell {
  text-align: center;
}
  .signature-label {
  text-align: center;
  font-size: 12px;
}
        </style>
      </head>
      <body>
      <div class="receipt">
      <div style="text-align:center;">
  <span class="copy-title">SCHOOL COPY</span>
</div>
     <div class="header">
  <img src="${praLogo}" class="logo" alt="Logo" />

  <div class="school-details">
    <div class="trust-name">
      Shri Niketan Education Foundation(R)
    </div>

    <div class="college-name">
      Little Wonders International Public School
    </div>

    <div class="address">
    Sector no 32,plot no 27-E,near Stadium Nava Nagar, Bagalkote, Karnataka 587103
    </div>
  </div>
</div>
     
     <div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Receipt No:</strong> ${fee.ReceiptID}
  </span>

  <span>
    <strong>Date:</strong>
    ${fee.ReceiptDate ? formatDate(fee.ReceiptDate) : "N/A"}
  </span>
</div>
<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Name of the Student:</strong> ${fee.StudentName || "N/A"}
  </span>
  </div>
<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Standard:</strong> ${fee.ClassName || "N/A"}
  </span>

  <span>
    <strong>DIV:</strong>
    ${fee.SectionName || "N/A"}
  </span>
</div>

<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Student ID:</strong> ${fee.StudentID || "N/A"}
  </span>

  <span>
    <strong>Mobile Number:</strong>
    ${fee.MobileNumber || "N/A"}
  </span>
</div>
<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Installment Type:</strong>
     1 ☐ &nbsp;&nbsp;
     2 ☐
  </span>

  <span>
    <strong>UTR:</strong>
    ${fee.Description && fee.Description.trim()
      ? fee.Description
      : "Cash Payment"}
  </span>
</div>

   
        <table>
          <tr>
            <th>SL NO</th>
            <th>Fee Name</th>
            <th>Amount (INR)</th>
          </tr>
         ${feeRows}
          <tr>
            <td colspan="2" class="bold right">Total</td>
           <td class="bold left">${totalAmount.toFixed(2)}</td>
             </tr>
            
        </table>
       <div style="display:flex; margin:10px 0;">
  <span>
    <strong>Received cash(Rs.Inwords):</strong>
  </span>

  <span>
    <strong>${amountWords}</strong>
   
  </span>
</div>
        <table class="signature-table">
<tr>
<td class="sign-cell">
  <div class="signature-line"></div>
  <div class="signature-label">Depositor Sign</div>
</td>

<td class="sign-cell">
  <div class="signature-line"></div>
  <div class="signature-label">Cashier / Fee Collection Officer</div>
</td>
</tr>
</table>
</div>
<div class="cutline">
  
</div>
  <div class="receipt">
  <div style="text-align:center;">
  <span class="copy-title">PARENTS' COPY</span>
</div>
        <div class="header">
  <img src="${praLogo}" class="logo" alt="Logo" />

  <div class="school-details">
    <div class="trust-name">
      Shri Niketan Education Foundation(R)
    </div>

    <div class="college-name">
      Little Wonders International Public School
    </div>

    <div class="address">
    Sector no 32,plot no 27-E,near Stadium Nava Nagar, Bagalkote, Karnataka 587103
    </div>
  </div>
</div>
     
     <div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Receipt No:</strong> ${fee.ReceiptID}
  </span>

  <span>
    <strong>Date:</strong>
    ${fee.ReceiptDate ? formatDate(fee.ReceiptDate) : "N/A"}
  </span>
</div>
<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Name of the Student:</strong> ${fee.StudentName || "N/A"}
  </span>
  </div>
<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Standard:</strong> ${fee.ClassName || "N/A"}
  </span>

  <span>
    <strong>DIV:</strong>
    ${fee.SectionName || "N/A"}
  </span>
</div>

<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Student ID:</strong> ${fee.StudentID || "N/A"}
  </span>

  <span>
    <strong>Mobile Number:</strong>
    ${fee.MobileNumber || "N/A"}
  </span>
</div>
<div style="display:flex; justify-content:space-between; margin:10px 0;">
  <span>
    <strong>Installment Type:</strong>
     1 ☐ &nbsp;&nbsp;
     2 ☐
  </span>

  <span>
    <strong>UTR:</strong>
    ${fee.Description && fee.Description.trim()
      ? fee.Description
      : "Cash Payment"}
  </span>
</div>

   
        <table>
          <tr>
            <th>SL NO</th>
            <th>Fee Name</th>
            <th>Amount (INR)</th>
          </tr>
            ${feeRows}
          <tr>
            <td colspan="2" class="bold right">Total</td>
          <td class="bold left">${totalAmount.toFixed(2)}</td>
             </tr>
            
        </table>
       <div style="display:flex; margin:10px 0;">
  <span>
    <strong>Received cash(Rs.Inwords):</strong>
  </span>

  <span>
    <strong>${amountWords}</strong>
   
  </span>
</div>
        <table class="signature-table">
<tr>
<td class="sign-cell">
  <div class="signature-line"></div>
  <div class="signature-label">Depositor Sign</div>
</td>

<td class="sign-cell">
  <div class="signature-line"></div>
  <div class="signature-label">Cashier / Fee Collection Officer</div>
</td>
</tr>
</table>
</div>

        <script>
          window.onload = function() {
            window.print();
            setTimeout(() => window.close(), 100);
          };
        </script>
      </body>
      </html>
    `;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(receiptContent);
    printWindow.document.close();
};
const handleDelete = (receiptId) => {
  const confirmDelete = window.confirm(`Are you sure you want to delete Receipt No: ${receiptId}?`);
  if (confirmDelete) {
    fetch(`${BASE_URL}/api/deleteReceipt/${receiptId}`, {
      method: "DELETE"
    })
      .then((res) => res.json())
      .then((data) => {
        alert("Receipt deleted successfully.");
        // Refresh the paidFees list
        setPaidFees(prev => prev.filter(fee => fee.ReceiptID !== receiptId));
      })
      .catch((err) => {
        console.error(err);
        alert("Error deleting receipt.");
      });
  }
};
// Open modal for a specific fee
const openConcessionModal = (index) => {
  setCurrentFeeIndex(index);
  setShowConcessionModal(true);
};
const onApplyClick = () => {
  if (!concessionReferredBy.trim()) {
    alert("Please enter Concession Referred By before applying.");
    return;
  }
  if (currentFeeIndex !== null) {
  handleApplyConcession(currentFeeIndex, concessionReferredBy);
  setShowConcessionModal(false);
  setConcessionReferredBy("");
   }
  /* handleApplyConcession(currentFeeIndex, concessionReferredBy);
  setShowConcessionModal(false);
  setConcessionReferredBy(""); */
};
const hasBatchConcessions = concessions.some((c) => c > 0);
//FOR ALL FEE CATEGORY CONCESSION AT A TIME
const onApplyAllClick = () => {
  if (!concessionReferredBy.trim()) {
    alert("Please enter Concession Referred By before applying.");
    return;
  }
  // filter only fees with non-zero concession
  const concessionsToApply = fees
    .map((fee, index) => ({
      fee,
      concessionAmount: concessions[index] || 0,
    }))
    .filter(item => item.concessionAmount > 0);

  if (concessionsToApply.length === 0) {
    alert("Please enter at least one concession before applying.");
    return;
  }
  handleApplyAllConcessions(concessionsToApply, concessionReferredBy);
  setShowConcessionModal(false);
  setConcessionReferredBy("");
};
const handleApplyAllConcessions = async (concessionsToApply, referredBy) => {
  try {
    await axios.post(`${BASE_URL}/api/addConcessionsBatch`, {
      studentId,
      academicYearId: dett.academicYearId,
      courseId: dett.courseId,
      classId: dett.classId,
      date: selectedDate,
      createdBy: sessionStorage.getItem("adminName"),
      concessionReferredBy: referredBy,
      concessions: concessionsToApply.map(({ fee, concessionAmount }) => ({
        categoryId: fee.CategoryID,
        fees: fee.Fees,
        concessionAmount,
        finalAmount: Math.max(fee.Fees - concessionAmount, 0),
      })),
    });
    alert("All concessions applied successfully!");
    fetchFees();
    setConcessions([]); // reset
    setDisabledApply({});
  } catch (error) {
    console.error("Error applying concessions:", error);
    alert("Failed to apply concessions. Please try again.");
  }
};
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Payment Page
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <strong>Academic Year:</strong> {paymentDetails.AcademicYearName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <strong>Course:</strong> {paymentDetails.CourseName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <strong>Class:</strong> {paymentDetails.ClassName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <strong>Student Name:</strong> {paymentDetails.StudentName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Select Date"
              format="DD-MM-YYYY"
              value={selectedDate}
              onChange={(newDate) => setSelectedDate(newDate)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Box sx={{ mt: 3, overflowX: "auto" }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fees Name</TableCell>
              <TableCell>Amount (INR)</TableCell>
              <TableCell>Concession</TableCell>
              <TableCell>Apply</TableCell>
              <TableCell>Final Amount</TableCell>
              <TableCell>Balance</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Paying Now</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fees.map((fee, index) => (
              <TableRow key={index}>
                <TableCell>{fee.CategoryName}</TableCell>
                <TableCell>{fee.Fees}</TableCell>
                <TableCell>
  <TextField
    type="number"
    value={concessions[index] || 0}
    onChange={(e) => handleConcessionChange(e, index, fee)}
    fullWidth
    disabled={disabledApply[index]} // Disable input after applying
  />
</TableCell>
<TableCell>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            setCurrentFeeIndex(index);
            setShowConcessionModal(true);
          }}
          //disabled={disabledApply[index]}
           disabled={disabledApply[index] || (concessions[index] || 0) <= 0}
        >
          Apply
        </Button>
      </TableCell>
                <TableCell>{fee.finalAmount}</TableCell>
                <TableCell>{fee.balance}</TableCell>
                <TableCell>
                  <FormControl fullWidth>
                    <InputLabel>Method</InputLabel>
                    <Select
                      value={paymentMethods[fee.CategoryID] || ""}
                      onChange={(e) => handlePaymentMethodChange(e, fee.CategoryID)}
                    >
                      <MenuItem value="1">Cash</MenuItem>
                      <MenuItem value="2">Phone Pe</MenuItem>
                      <MenuItem value="3">Cash/Phone Pe</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                <Stack spacing={1}>
                  {paymentMethods[fee.CategoryID] === "1" && (
                    <TextField
                      type="text"
                      label="Cash"
                      value={paymentBreakdown[fee.CategoryID]?.cash || ""}
                      onChange={(e) => handleBreakdownChange(e, fee.CategoryID, "cash")}
                      inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]*"
  }}
                      fullWidth
                    />
                  )}
                  {paymentMethods[fee.CategoryID] === "2" && (
                     <>
                    <TextField
                      type="text"
                      label="PhonePe"
                      value={paymentBreakdown[fee.CategoryID]?.phonepe || ""}
                      onChange={(e) => handleBreakdownChange(e, fee.CategoryID, "phonepe")}
                      inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]*"
  }}
                      fullWidth
                    />
                   {/*  <TextField
    label="UTR Number"
    value={utrNumbers[fee.CategoryID] || ""}
    onChange={(e) =>
      setUtrNumbers((prev) => ({
        ...prev,
        [fee.CategoryID]: e.target.value,
      }))
    }
    fullWidth
  /> */}
                    </>
                  )}
                  {paymentMethods[fee.CategoryID] === "3" && (
                    <>
                      <TextField
                        type="text"
                        label="Cash"
                        value={paymentBreakdown[fee.CategoryID]?.cash || ""}
                        onChange={(e) => handleBreakdownChange(e, fee.CategoryID, "cash")}
                        inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]*"
  }}
                        fullWidth
                      />
                      <TextField
                        type="text"
                        label="PhonePe"
                        value={paymentBreakdown[fee.CategoryID]?.phonepe || ""}
                        onChange={(e) => handleBreakdownChange(e, fee.CategoryID, "phonepe")}
                        inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]*"
  }}
                        fullWidth
                      />
                     {/*  <TextField
    label="UTR Number"
    value={utrNumbers[fee.CategoryID] || ""}
    onChange={(e) =>
      setUtrNumbers((prev) => ({
        ...prev,
        [fee.CategoryID]: e.target.value,
      }))
    }
    fullWidth
  /> */}
                    </>
                  )}
                  </Stack>
                </TableCell>
                <TableCell>{payingNow[fee.CategoryID] || 0}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          {/* Show Apply All only if at least one concession > 0 */}
{hasBatchConcessions && (
  <Button
    variant="contained"
    color="secondary"
    onClick={() => {
      setCurrentFeeIndex(null); // batch mode
      setShowConcessionModal(true);
    }}
    style={{ marginTop: "16px" }}
  >
    Apply All Concessions
  </Button>
)}
        </Table>
{/* Modal for both single & batch */}
<Dialog open={showConcessionModal} onClose={() => setShowConcessionModal(false)}>
  <DialogTitle>Apply Concession</DialogTitle>
  <DialogContent>
    <TextField
      label="Concession Referred By"
      value={concessionReferredBy}
      onChange={(e) => setConcessionReferredBy(e.target.value)}
      fullWidth
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setShowConcessionModal(false)}>Cancel</Button>
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        if (currentFeeIndex === null) {
          // batch mode
          onApplyAllClick();
        } else {
          // single mode
          //onApplyClick(currentFeeIndex);
          onApplyClick();
        }
      }}
    >
      Apply
    </Button>
  </DialogActions>
</Dialog>
      </TableContainer>
</Box>
{/* <FormControl fullWidth margin="normal">
  <InputLabel>Installment</InputLabel>
  <Select
    value={installmentType}
    onChange={(e) => setInstallmentType(e.target.value)}
  >
    <MenuItem value={1}>Installment 1</MenuItem>
    <MenuItem value={2}>Installment 2</MenuItem>
  </Select>
</FormControl> */}
 
 
                 
      <TextField label="UTR/Description" margin="normal" value={description} onChange={(e) => setDescription(e.target.value)} />
      
      <Button variant="contained" color="primary" onClick={handleSavePayment} disabled={isSaveDisabled}
      sx={{ mt: 2, width: "100%" }}
      >
        Save Payment
      </Button>
      <Typography variant="h6" gutterBottom>
        Paid Fees Details
      </Typography>
      <TableContainer component={Paper} sx={{ width: "100%", overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Receipt No</strong></TableCell>
              <TableCell><strong>Date</strong></TableCell>
              <TableCell><strong>Category Name</strong></TableCell>
              <TableCell><strong>Amount (INR)</strong></TableCell>
              <TableCell><strong>Action</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paidFees.length > 0 ? (
              paidFees.map((fee, index) => (
                <TableRow key={index}>
                  <TableCell>{fee.ReceiptID}</TableCell>
                 <TableCell>{dayjs(fee.ReceiptDate).format("DD/MM/YYYY")}</TableCell>
                  <TableCell>{fee.CategoryName}</TableCell>
                  <TableCell>{fee.PaidFees}</TableCell>
                  <TableCell>
                   {/*  <IconButton color="secondary" onClick={() => handlePrint(fee)}> */}
                    <IconButton color="secondary" onClick={() => handlePrint(fee.ReceiptID)}>
                      <PrintIcon />
                    </IconButton>
                     <IconButton color="error" onClick={() => handleDelete(fee.ReceiptID)}>
    <DeleteIcon />
  </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No fees paid yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};
export default PaymentPage;
